
import React from "react";
import { useSession } from "next-auth/client";
import {
  Button, useDisclosure,
  Flex, Text,
  Input,
  Box,
  Heading,
} from "@chakra-ui/react";
import { Stack } from "@chakra-ui/layout";
import toast from "react-hot-toast";
import { firebaseClient } from "firebaseClient";
import { CustomSection } from "components/custom-section";
import { getAccount, logout } from "utils/sessionHelper";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { postData } from "../../utils/helpers";
import { DeleteIcon } from "components/icons/DeleteIcon";
import { colors } from "theme/colors/colors";
import { textStyle } from "theme/names";

export function DangerZone() {
  const [session] = useSession();
  const [newAccount, setNewAccount] = React.useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenTransfert, onOpen: onOpenTransfert, onClose: onCloseTransfert } = useDisclosure();

  const handleTransfert = async () => {

    let data = {
      transfertFrom: session?.user?.data?.twUserName,
      transfertTo: newAccount,
    }

    let transfert = await postData({
      url: "user-transfertAccount",
      token: "",
      data: data,
      session,
    });

    if (transfert.success)
      toast.success("Account transfered - you can now use the new account");
    else
      toast.error("Error: " + transfert.error);
  }

  const handleClick = () => {
    const subscription = getAccount(session)?.subscription;
    if (subscription?.isSubscribed && !getAccount(session)?.subStatus?.includes("CancelRequest")) {
      toast.error(
        "Can't delete your account, you have an active subscription. Unsubscribe first"
      );
      return;
    }

    onOpen();
  };

  const handleDelete = async () => {

    postData({
      url: "user-deleteTweetButlerAccount",
      token: "",
      data: {},
      session: session,
    });

    const db = firebaseClient.firestore();
    let docTweets = await db.collection("users").doc(session?.user?.uid).collection("tweets").get();
    console.log("nb tweets to delete: " + docTweets.docs?.length);

    // await async.mapLimit(docTweets.docs, 10, async (doc) => {
    docTweets.forEach((doc) => {
      console.log("delete tweets " + doc.id);
      db.collection("users").doc(session?.user?.uid).collection("tweets").doc(doc.id).delete();
    });

    let docAccounts = await db.collection("users").doc(session?.user?.uid).collection("accounts").get();
    docAccounts.forEach((doc) => {
      console.log("delete account " + doc.id);
      db.collection("users").doc(session?.user?.uid).collection("accounts").doc(doc.id).delete();
    });

    await db.collection("users").doc(session?.user?.uid).delete();

    logout();
  };

  const username = getAccount(session)?.twUserName;
  return (
    <Box>
      <Box mt={20}>
        <Text
          // fontSize="3xl"
          textStyle={textStyle["h3.bold.standard"]}
          {...{
            p: 4,
            color: colors.alert.lightMode.default,
            _dark: { color: colors.alert.darkMode.default },
          }}
        >
          Danger Zone
        </Text>
      </Box>
      <Flex flexDirection="column" gap={4}>
        <CustomSection
          title="Transfer account"
          description="Transfer all your data and subscription to a new Tweet Hunter account. The new account needs to be already created. This action may erase some data in the destination account. "
          css={{ maxW: "800px" }}
        >
          <Flex flexWrap="wrap" gap="4">
            <Input w="300px" value={newAccount} onChange={(e) => setNewAccount(e.target.value)} placeholder="new_account" />
            <Button
              w="200px"
              colorScheme="red"
              size="md"
              width="max-content"
              onClick={onOpenTransfert}
              variant={"secondary"}
            >
              Transfer my account
            </Button>
          </Flex>
        </CustomSection>
        <CustomSection
          title="Account Deletion"
          description="Careful, these actions are permanent"
        >
          <Stack padding={4}>
            <Button
              colorScheme="red"
              size="md"
              width="max-content"
              onClick={handleClick}
              variant={"secondary"}
              leftIcon={DeleteIcon}
            >
              Delete my account
            </Button>
          </Stack>
        </CustomSection>
      </Flex>
      <ConfirmPopup
        isOpen={isOpenTransfert}
        onClose={onCloseTransfert}
        title="Transfer account confirmation"
        allowClickBackground={true}
        body={
          "This will permanently transfer your account and all your data associated with it."
        }
        callback={handleTransfert}
      />
      <ConfirmPopup
        isOpen={isOpen}
        onClose={onClose}
        title="Delete account confirmation"
        allowClickBackground={true}
        body={
          "This will permanently delete your account and all your data associated with it."
        }
        callback={handleDelete}
      />
    </Box>
  );
}
